import {Lang} from 'yougile-lang'

export const handleErrorMsg = (origMessage: string): string => {
  if (!origMessage) {
    return ''
  }

  if (origMessage?.includes('429')) {
    return Lang.msg.boardAppearance.unsplashErrorRequestLimit
  }

  if (origMessage?.includes('403')) {
    return Lang.msg.boardAppearance.noAccess
  }

  if (origMessage === 'Cannot get photo from unsplash') {
    return Lang.msg.boardAppearance.unsplashCommonError
  }

  return origMessage
}
